
import { useState, useEffect } from 'react';

export function usePWAInstall() {

    const [installPrompt, setInstallPrompt] = useState(null);
    const [isInstalled, setIsInstalled] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);

    useEffect(() => {
        const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
        setIsIOS(ios);

        const standalone =
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true;
        setIsInStandaloneMode(standalone);

        // Check if the event was already captured before React mounted.
        // The index.html script captures it early to avoid missing the event.
        if (window.__pwaInstallEvent) {
            setInstallPrompt(window.__pwaInstallEvent);
            window.__pwaInstallEvent = null;
        }

        // Also keep listening in case it fires after React mounts
        const handler = (e) => {
            e.preventDefault();
            setInstallPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', handler);

        window.addEventListener('appinstalled', () => {
            setIsInstalled(true);
            setInstallPrompt(null);
        });

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const triggerInstall = async () => {
        if (!installPrompt) return false;
        installPrompt.prompt();
        const { outcome } = await installPrompt.userChoice;
        if (outcome === 'accepted') setIsInstalled(true);
        setInstallPrompt(null);
        return outcome === 'accepted';
    };

    return {
        canInstall: !!installPrompt,
        isIOS,
        isInstalled,
        isInStandaloneMode,
        triggerInstall,
    };
}